export default __webpack_public_path__ + "static/media/modal-error.2173af4c.svg";